const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const PARAMS = Object.freeze({
  staff: "staffInvitation",
  portal: "portalInvitation",
});

export const readAccountInvitationIntent = (location = typeof window !== "undefined" ? window.location : null) => {
  if (!location?.search) return null;
  const query = new URLSearchParams(location.search);
  const matches = Object.entries(PARAMS)
    .map(([kind, key]) => ({ kind, id: String(query.get(key) || "").trim() }))
    .filter(({ id }) => UUID_PATTERN.test(id));
  return matches.length === 1 ? matches[0] : null;
};

export const clearAccountInvitationIntent = ({
  location = typeof window !== "undefined" ? window.location : null,
  history = typeof window !== "undefined" ? window.history : null,
} = {}) => {
  if (!location || !history?.replaceState) return;
  const query = new URLSearchParams(location.search || "");
  Object.values(PARAMS).forEach((key) => query.delete(key));
  const search = query.toString();
  history.replaceState(history.state, "", `${location.pathname}${search ? `?${search}` : ""}${location.hash || ""}`);
};

